export default __webpack_public_path__ + "static/media/menu_04.84bdcf92.jpg";